import React, { useContext, useEffect, useState } from 'react';
import axios from 'axios';
import { FaFacebook, FaInstagram, FaTwitter, FaPinterest, FaTumblr, FaYoutube, FaSnapchatGhost, FaTiktok, FaLinkedin } from "react-icons/fa";
import { useNavigate } from 'react-router-dom';
import { LoginContext } from '../../Contexts/LoginContext';

const BuyerFooter = () => {

  const [socialLinks, setSocialLinks] = useState({});
  const navigate = useNavigate();
  const { isLogin, user } = useContext(LoginContext);

  useEffect(() => {
    const fetchLinks = async () => {
      try {
        const { data } = await axios.get(`${process.env.REACT_APP_Backend_Host_Name}/api/v1/settings/admin/social-links`);
        setSocialLinks(data.socialLinks || {});
      } catch (error) {
        console.error("Failed to fetch social links", error);
      }
    };
    fetchLinks();
  }, []);

  return (
    <footer className="buyerFooter">
      <div className="buyerFooterBackground"></div>
      <div className="buyerFooterContent">
        <div className="buyerFooterSection">
          <h4>ABOUT</h4>
          <ul>
            <li onClick={() => navigate("/")}>HOME</li>
            <li onClick={() => navigate("/contact")}>CONTACT US</li>
            <li onClick={() => navigate("/terms")}>TERMS & CONDITIONS</li>
            <li onClick={() => navigate("/blogs")}>BLOGS</li>
          </ul>
        </div>
        <div className="buyerFooterSection">
          <h4>USEFUL LINKS</h4>
          <ul>
            <li onClick={() => navigate("/categories")}>CATEGORIES</li>
            <li onClick={() => navigate("/products")}>PRODUCTS</li>
            <li onClick={() => navigate("/b2b")}>B2B MARKETPLACE</li>
            <li onClick={() => navigate("/postRequirements")}>POST YOUR REQUIREMENTS</li>
            <li onClick={() => navigate("/bookmarkSellers")}>MY BOOKMARKS</li>
          </ul>
        </div>
        <div className="buyerFooterSection">
          <h4>ACCOUNT</h4>
          <ul>
            {!isLogin && <li onClick={() => navigate("/signin")}>SIGN IN</li>}
            {!isLogin && <li onClick={() => navigate("/signup")}>CREATE ACCOUNT</li>}
            {isLogin && <li onClick={() => navigate("/chats")}>INBOX</li>}
            <li onClick={() => navigate("/orders")}>ORDERS AS BUYER</li>
            <li onClick={() => navigate("/faq")}>FAQ</li>
            <li onClick={() => navigate("/settings")}>SETTINGS</li>
          </ul>
        </div>
        <div className="buyerFooterSection">
          <h4>SELLER CENTER</h4>
          <ul>
            {(!isLogin || (isLogin && user?.role !== "seller")) && <li onClick={() => navigate("/becomeSeller")}>BECOME A SELLER</li>}
            {isLogin && user?.role === "seller" && <li onClick={() => navigate("/sellerDashboard")}>SELLER DASHBOARD</li>}
            {isLogin && user?.role === "seller" && <li onClick={() => navigate("/postings")}>MY POSTINGS</li>}
            {isLogin && user?.role === "seller" && <li onClick={() => navigate("/earnings")}>EARNINGS</li>}
            {isLogin && user?.role === "seller" && <li onClick={() => navigate("/seller/orders")}>ORDERS AS SELLER</li>}
          </ul>
        </div>
      </div>
      <div className="buyerFooterSocial" style={(!isLogin || (isLogin && user?.role !== "seller")) ? { marginBottom: "50px" } : {}}>
        {socialLinks.facebook && <a href={socialLinks.facebook} target="_blank" rel="noopener noreferrer"><FaFacebook className='icon' /></a>}
        {socialLinks.instagram && <a href={socialLinks.instagram} target="_blank" rel="noopener noreferrer"><FaInstagram className='icon' /></a>}
        {socialLinks.twitter && <a href={socialLinks.twitter} target="_blank" rel="noopener noreferrer"><FaTwitter className='icon' /></a>}
        {socialLinks.pinterest && <a href={socialLinks.pinterest} target="_blank" rel="noopener noreferrer"><FaPinterest className='icon' /></a>}
        {socialLinks.tumblr && <a href={socialLinks.tumblr} target="_blank" rel="noopener noreferrer"><FaTumblr className='icon' /></a>}
        {socialLinks.youtube && <a href={socialLinks.youtube} target="_blank" rel="noopener noreferrer"><FaYoutube className='icon' /></a>}
        {socialLinks.snapchat && <a href={socialLinks.snapchat} target="_blank" rel="noopener noreferrer"><FaSnapchatGhost className='icon' /></a>}
        {socialLinks.tiktok && <a href={socialLinks.tiktok} target="_blank" rel="noopener noreferrer"><FaTiktok className='icon' /></a>}
        {socialLinks.linkedin && <a href={socialLinks.linkedin} target="_blank" rel="noopener noreferrer"><FaLinkedin className='icon' /></a>}
      </div>
    </footer>
  );
};

export default BuyerFooter;
